<template>
  <div>403</div>
</template>

<script>
export default {

  name: 'Page403',

  methods: {
    
    /* **** back **** */
    back() {
      if(this.$route.query.noGoBack) {
        this.$router.push({ path: '/monitor' });
      } else {
        this.$router.go(-1);
      }
    },
    
  },

};
</script>
